// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyzeController from "./analyze_controller"
application.register("analyze", AnalyzeController)

import AttachablePickerController from "./attachable_picker_controller"
application.register("attachable-picker", AttachablePickerController)

import AuctionPanelController from "./auction_panel_controller"
application.register("auction-panel", AuctionPanelController)

import AuctionUpdateController from "./auction_update_controller"
application.register("auction-update", AuctionUpdateController)

import AutoClickController from "./auto_click_controller"
application.register("auto-click", AutoClickController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutoresizeController from "./autoresize_controller"
application.register("autoresize", AutoresizeController)

import BadgeController from "./badge_controller"
application.register("badge", BadgeController)

import BarController from "./bar_controller"
application.register("bar", BarController)

import BeaconController from "./beacon_controller"
application.register("beacon", BeaconController)

import BookClosePreviewController from "./book_close_preview_controller"
application.register("book-close-preview", BookClosePreviewController)

import BidController from "./bid_controller"
application.register("bid", BidController)

import BidSubmissionController from "./bid_submission_controller"
application.register("bid-submission", BidSubmissionController)

import BoardsFormController from "./boards_form_controller"
application.register("boards-form", BoardsFormController)

import BubbleController from "./bubble_controller"
application.register("bubble", BubbleController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import ClickerController from "./clicker_controller"
application.register("clicker", ClickerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleColumnsController from "./collapsible_columns_controller"
application.register("collapsible-columns", CollapsibleColumnsController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import ContactPickerController from "./contact_picker_controller"
application.register("contact-picker", ContactPickerController)

import ContactsDirectoryController from "./contacts_directory_controller"
application.register("contacts-directory", ContactsDirectoryController)

import ContentSignatureFieldsController from "./content_signature_fields_controller"
application.register("content-signature-fields", ContentSignatureFieldsController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CssVariableCounterController from "./css_variable_counter_controller"
application.register("css-variable-counter", CssVariableCounterController)

import DetailsController from "./details_controller"
application.register("details", DetailsController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DialogManagerController from "./dialog_manager_controller"
application.register("dialog-manager", DialogManagerController)

import DisableButtonsController from "./disable_buttons_controller"
application.register("disable-buttons", DisableButtonsController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import DisclaimerSignController from "./disclaimer_sign_controller"
application.register("disclaimer-sign", DisclaimerSignController)

import DragAndDropController from "./drag_and_drop_controller"
application.register("drag-and-drop", DragAndDropController)

import DropdownMenuController from "./dropdown_menu_controller"
application.register("dropdown-menu", DropdownMenuController)

import DropdownSubmenuController from "./dropdown_submenu_controller"
application.register("dropdown-submenu", DropdownSubmenuController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DynamicSignersController from "./dynamic_signers_controller"
application.register("dynamic-signers", DynamicSignersController)

import ElementRemovalController from "./element_removal_controller"
application.register("element-removal", ElementRemovalController)

import EmailInputController from "./email_input_controller"
application.register("email-input", EmailInputController)

import FetchOnVisibleController from "./fetch_on_visible_controller"
application.register("fetch-on-visible", FetchOnVisibleController)

import FileDropZoneController from "./file_drop_zone_controller"
application.register("file-drop-zone", FileDropZoneController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import FilterSettingsController from "./filter_settings_controller"
application.register("filter-settings", FilterSettingsController)

import FormController from "./form_controller"
application.register("form", FormController)

import FrameController from "./frame_controller"
application.register("frame", FrameController)

import FrameReloaderController from "./frame_reloader_controller"
application.register("frame-reloader", FrameReloaderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import ImageLightboxController from "./image_lightbox_controller"
application.register("image-lightbox", ImageLightboxController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InviteContextController from "./invite_context_controller"
application.register("invite-context", InviteContextController)

import KnobController from "./knob_controller"
application.register("knob", KnobController)

import KnowledgeLinksFormController from "./knowledge_links_form_controller"
application.register("knowledge-links-form", KnowledgeLinksFormController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ListSearchController from "./list_search_controller"
application.register("list-search", ListSearchController)

import LocalSaveController from "./local_save_controller"
application.register("local-save", LocalSaveController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import MagicLinkController from "./magic_link_controller"
application.register("magic-link", MagicLinkController)

import MilestoneExpandController from "./milestone_expand_controller"
application.register("milestone-expand", MilestoneExpandController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectionComboboxController from "./multi_selection_combobox_controller"
application.register("multi-selection-combobox", MultiSelectionComboboxController)

import NavSectionExpanderController from "./nav_section_expander_controller"
application.register("nav-section-expander", NavSectionExpanderController)

import NavigableListController from "./navigable_list_controller"
application.register("navigable-list", NavigableListController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationBellController from "./notification_bell_controller"
application.register("notification-bell", NotificationBellController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import NotificationsTrayController from "./notifications_tray_controller"
application.register("notifications-tray", NotificationsTrayController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OutletAutoSaveController from "./outlet_auto_save_controller"
application.register("outlet-auto-save", OutletAutoSaveController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PhoneNumbersController from "./phone_numbers_controller"
application.register("phone-numbers", PhoneNumbersController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import ReactionDeleteController from "./reaction_delete_controller"
application.register("reaction-delete", ReactionDeleteController)

import ReactionEmojiController from "./reaction_emoji_controller"
application.register("reaction-emoji", ReactionEmojiController)

import RecipientsController from "./recipients_controller"
application.register("recipients", RecipientsController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import RelatedElementController from "./related_element_controller"
application.register("related-element", RelatedElementController)

import RetargetLinksController from "./retarget_links_controller"
application.register("retarget-links", RetargetLinksController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignatureFieldPlacementController from "./signature_field_placement_controller"
application.register("signature-field-placement", SignatureFieldPlacementController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SigningPreviewController from "./signing_preview_controller"
application.register("signing-preview", SigningPreviewController)

import SoftKeyboardController from "./soft_keyboard_controller"
application.register("soft-keyboard", SoftKeyboardController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SsnRevealController from "./ssn_reveal_controller"
application.register("ssn-reveal", SsnRevealController)

import StatementImportController from "./statement_import_controller"
application.register("statement-import", StatementImportController)

import SubmittingController from "./submitting_controller"
application.register("submitting", SubmittingController)

import SupportWidgetController from "./support_widget_controller"
application.register("support-widget", SupportWidgetController)

import SupportWidgetTrixController from "./support_widget_trix_controller"
application.register("support-widget-trix", SupportWidgetTrixController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import TaskCardController from "./task_card_controller"
application.register("task-card", TaskCardController)

import TaskEditController from "./task_edit_controller"
application.register("task-edit", TaskEditController)

import TaskStatusToggleController from "./task_status_toggle_controller"
application.register("task-status-toggle", TaskStatusToggleController)

import TemplateTypeToggleController from "./template_type_toggle_controller"
application.register("template-type-toggle", TemplateTypeToggleController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimezoneCookieController from "./timezone_cookie_controller"
application.register("timezone-cookie", TimezoneCookieController)

import ToggleClassController from "./toggle_class_controller"
application.register("toggle-class", ToggleClassController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleEnableController from "./toggle_enable_controller"
application.register("toggle-enable", ToggleEnableController)

import ToggleFieldsController from "./toggle_fields_controller"
application.register("toggle-fields", ToggleFieldsController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TransactionTypeFormController from "./transaction_type_form_controller"
application.register("transaction-type-form", TransactionTypeFormController)

import TrixAttachmentController from "./trix_attachment_controller"
application.register("trix-attachment", TrixAttachmentController)

import TurboNavigationController from "./turbo_navigation_controller"
application.register("turbo-navigation", TurboNavigationController)

import UserAutocompleteController from "./user_autocomplete_controller"
application.register("user-autocomplete", UserAutocompleteController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import UploadPreviewController from "./upload_preview_controller"
application.register("upload-preview", UploadPreviewController)

import VerbiageController from "./verbiage_controller"
application.register("verbiage", VerbiageController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)
